export interface CategoryFilterChip {
  token: string
  name: string
  tier: number
}

/** One visible chip per selected industry token (no hierarchy collapse). */
export function buildCategoryFilterChips(
  selectedTokens: Array<string>,
  tokenMeta: Map<string, { name: string; tier: number }>,
): Array<CategoryFilterChip> {
  return selectedTokens
    .map((token) => {
      const meta = tokenMeta.get(token)
      return {
        token,
        name: meta?.name ?? token,
        tier: meta?.tier ?? 0,
      }
    })
    .sort((a, b) => b.tier - a.tier || a.name.localeCompare(b.name))
}
